import Component from '@glimmer/component';
import { parseUserAgent } from '../lib/user-agent.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<span class=\'float-left\' ...attributes>\n  <div class=\'platform {{this.classNamesProperty}}\' title={{this.titleProperty}}></div>\n</span>");

class BbUserPlatformComponent extends Component {
  get classNamesProperty() {
    if (!this.args.user) {
      return;
    }
    const {
      os
    } = parseUserAgent(this.args.user.user_agent);
    switch (os.name) {
      case 'Mac OS':
      case 'Apple':
        return 'Apple';
      case undefined:
        return 'Others';
      default:
        return os.name;
    }
  }
  get titleProperty() {
    if (!this.args.user) {
      return;
    }
    const {
      os
    } = parseUserAgent(this.args.user.user_agent);
    return os.name + ' ' + os.version;
  }
}
setComponentTemplate(TEMPLATE, BbUserPlatformComponent);

export { BbUserPlatformComponent as default };
//# sourceMappingURL=bb-user-platform.js.map
